"use client";

import * as React from "react";
import { BreadcrumbsSection as BaseBreadcrumbsSection } from "@repo/ui-parkmobile/sections/BreadcrumbsSection";
import { useGlobalDataContext } from "../GlobalDataContext";
import { BreadcrumbListSchema } from "../schema";
import { deleteAutoSlug } from "@/utils/autoSlug";

/**
 * Routes where breadcrumbs should be hidden
 */
const HIDDEN_BREADCRUMBS_ROUTES = ["parking/locations"];

export interface BreadcrumbsSectionProps {
  backgroundColor?: "none" | "accent" | "accent-light" | "light";
  topPadding?: "none" | "default" | "large";
  bottomPadding?: "none" | "default";
}

export const BreadcrumbsSection: React.FC<BreadcrumbsSectionProps> = (props) => {
  const { breadcrumbs, currentSlug } = useGlobalDataContext();

  const normalizedSlug = deleteAutoSlug(currentSlug ?? "");
  const shouldHideBreadcrumbs = HIDDEN_BREADCRUMBS_ROUTES.includes(normalizedSlug);

  if (shouldHideBreadcrumbs) {
    return null;
  }

  return (
    <>
      <BreadcrumbListSchema items={breadcrumbs} />
      <BaseBreadcrumbsSection items={breadcrumbs} {...props} />
    </>
  );
};
